import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _, { debounce } from 'lodash';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import ActionableHeader, { BrowserAlertByFilter } from '../ActionableHeader';
import { classNames, downloadFileById } from '../../../../utils';
import Text from '../../../../components/Text';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import { ACTIONABLE_TICKET_MAPPING, GENDER, WT } from '../../../../comm/constant';
import { bedStatusAPI, eadmissionAPI } from '../../../../apis';
import StyleButton from '../../../../components/StyleButton';
import { useQuery } from '../../../../utils/useQuery';
import { useActionableSettings, useActionableTicketReminder, useGetLoginInfo } from '../../../../utils/hooks';
import { LoginPop } from '../../../../components/Login';
import TransferOutTable from '../../../BedStatus/components/TransferOut/TransferOutTable';
import { ResponseCommCodeEnum, alertMsg } from '../../../../apis/commlogic';
import { i18n } from '../../../../language';
import { BookingTable } from '../../../BedStatus/components';
import { initAdmissionFilter } from '../..';
import { DocIcon } from '../../../../components/Icon';
import exportPwdExcel from '../../../../utils/exportPwdExcel';
import AutoCompleteMultiCheckbox from '../../../../components/AutoCompleteMultiCheckbox';
import { ADMISSION_FILTER } from '../../../../comm/constant/storage';
import { revampTableList } from '../../../../utils/newBedStatusUtil';
import AeNoScanInput from '../../components/AeNoScanInput';
import { handleAdmissionFormRedirect } from '../../../../utils/admissionUtil';
import useIpad from '../../../../utils/useIpad';
import EAdmissionTITable from '../../TransferIn/components/TransferInTable';
import TransferInPop from '../../TransferIn/components/TransferOutPop';
import {
  buildUpdateTransferInParams,
  fetchTransferInPopupOptions,
  initTransferInPopupOptions,
} from '../../TransferIn/transferInRequestUtil';
import TicketTable from './TicketTable/TicketTable';
import AckHistoryFilter from './AckHistory/HistoryFilter';

const ActionableDashboard = () => {
  const [isShowLoginPop, setIsShowLoginPop] = useState(false);
  const [isTransferInPopOpen, setIsTransferInPopOpen] = useState(false);
  const [transferInEditData, setTransferInEditData] = useState(null);
  const [transferInPopupOptions, setTransferInPopupOptions] = useState(initTransferInPopupOptions);
  const query = useQuery();
  const history = useHistory();
  const loginInfo = useGetLoginInfo();
  const [detailOpen] = useState(false);
  const classes = useStyles({ detailOpen });
  const [specialty, setSpecialty] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [filter, setFilter] = useState(initFilter);
  const [ticketList, setTicketList] = useState({
    ackAllDisplay: false,
    count: 0,
    data: [],
  });
  const [refreshTickets, setRefreshTickets] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [tickets] = useActionableTicketReminder('audio', query.type, [
    query.ticketType,
    query.tableName,
    refreshTickets,
    refresh,
  ]);
  const [refreshTicketList, setRefreshTicketList] = useState(false);
  const [actionableSetting] = useActionableSettings();
  const [sort, setSort] = useState({
    sortKey: '',
    sortOrder: '',
  });
  const tableRef = useRef(null);
  const [BsMlookupList, setBsMlookupList] = useState(null);
  const [historySubTabValue, setHistorySubTabValue] = useState(0);
  const [busstopOptions, setBusstopOptions] = useState([]);
  const pendingBarcodeAeNoRef = useRef('');
  const isIpad = useIpad();

  // 更新缓存
  useEffect(() => {
    try {
      const storageFilter = JSON.parse(localStorage.getItem(ADMISSION_FILTER));
      localStorage.setItem(ADMISSION_FILTER, JSON.stringify({ ...storageFilter, specialtys: filter.specialtys }));
    } catch (error) {
      console.log(error);
    }
  }, [filter.specialtys]);

  // 判断当前表格类型
  const tableType = useMemo(() => {
    if (_.some(transferInType, (item) => item === query.ticketType)) {
      return 'T/I';
    } else if (_.some(transferOutType, (item) => item === query.ticketType)) {
      return 'T/O';
    } else {
      return 'ADM';
    }
  }, [query.ticketType]);
  const isEAdmissionTI = query.ticketType === 'RECVWR';

  const isBsMode = query.type === 'BS';
  const isHistory = query.ticketType === 'history';
  const isAdm = tableType === 'ADM';
  const isTI = tableType === 'T/I';
  const isTO = tableType === 'T/O';

  // 防抖函數
  const debouncedFilter = useRef(
    debounce(async (props) => {
      setFilter(props);
    }, 1000)
  ).current;

  // 切換tab
  const handleSelect = (ticketType, tableName) => () => {
    if (ticketType === query.ticketType) {
      return;
    }
    setFilter(initFilter);
    setTicketList({
      ackAllDisplay: false,
      count: 0,
      data: [],
    });
    if (ticketType === 'history') {
      history.replace(
        `/actionableDashboard${query.type === 'BS' ? 'Bs' : 'Adm'}?type=${query.type}&ticketType=history`
      );
    } else {
      history.replace(
        `/actionableDashboard${query.type === 'BS' ? 'Bs' : 'Adm'}?type=${
          query.type
        }&ticketType=${ticketType}&tableName=${tableName}`
      );
    }
  };

  const handleSelectSubTab = (item) => () => {
    if (historySubTabValue === item.value) {
      return;
    }
    setTicketList({
      ackAllDisplay: false,
      count: 0,
      data: [],
    });
    setHistorySubTabValue(item.value);
  };

  // 修改过滤条件
  const handleFilterSelect = (type) => (value) => {
    switch (type) {
      case 'waitTime':
      case 'sex':
      case 'startDate':
      case 'endDate':
      case 'specialtys':
      case 'busstop':
      case 'aeNo':
        setFilter((preFilter) => ({
          ...preFilter,
          [type]: value,
        }));
        break;
      case 'corpId':
        setFilter((preFilter) => ({
          ...preFilter,
          [type]: !preFilter[type],
        }));
        break;
      default:
        debouncedFilter((preFilter) => ({
          ...preFilter,
          [type]: value,
        }));
        break;
    }
  };

  useEffect(() => {
    setTabs(
      _.map(tickets, (item) => ({
        ...item,
        flag: item.ticketType === query.ticketType,
        disabled: item.count === 0,
        falsh: item.count > 0,
      }))
    );
  }, [tickets]);

  const historyParams = {
    filter: {
      sex: filter.sex,
      specialtys: _.map(filter.specialtys, (item) => item.value),
      waitTime: filter.waitTime,
      ackBy: filter.ackBy,
      startDate: moment(filter.startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(filter.endDate).format('YYYY-MM-DD HH:mm:ss'),
      corpId: filter.corpId ? loginInfo.corpID : '',
      busstops: _.map(filter.busstop, (item) => item.value),
      aeNo: filter.aeNo,
    },
    // pageNo: 1,
    // pageSize: 10,
    sort: {
      column: sort.sortKey,
      order: sort.sortOrder,
    },
    type: isBsMode ? ACK_BS_HISTORY_ENUM[historySubTabValue] : null,
  };

  const redirectCallBack = (eaId = '', transferRequestId = '') => {
    const redirectPath =
      isBsMode || query.ticketType === 'PWA'
        ? `/${'bedstatus'}Form/${eaId}?transferRequestId=${transferRequestId}&actionableMode=1`
        : `/${'admission'}Form/${eaId}?actionableMode=1`;
    history.push(redirectPath);
  };

  // 获取数据
  const getTicketList = async () => {
    let params = {};
    let admissionList = [];
    try {
      if (isHistory) {
        if (
          moment(filter.startDate).isBetween(
            moment(filter.endDate).add(-3, 'days').add(-1, 'minutes'),
            moment(filter.endDate),
            'minutes',
            '[]'
          )
        ) {
          const { result } = isBsMode
            ? await eadmissionAPI.getAckBsHistory(historyParams)
            : await eadmissionAPI.getAckHistory(historyParams);
          admissionList = result;
        }
      } else {
        params = isAdm
          ? {
              filter: {
                sex: filter.sex,
                specialtys: _.map(filter.specialtys, (item) => item.value),
                waitTime: filter.waitTime,
                busstops: _.map(filter.busstop, (item) => item.value),
                aeNo: filter.aeNo,
              },
              tableName: query.tableName,
              ticketType: query.ticketType,
              sort: {
                column: sort.sortKey,
                order: sort.sortOrder,
              },
            }
          : {
              tableName: query.tableName,
              ticketType: query.ticketType,
            };
        const { result } = await eadmissionAPI.getTicketList(params, { isHideLoading: true });
        const revampResult = {
          ...result,
          data: await revampTableList(result?.data),
        };
        admissionList = revampResult;
      }
      setTicketList(admissionList);
      if (isHistory || isAdm) {
        handleAdmissionFormRedirect({
          admissionList: admissionList?.data,
          history,
          params: isHistory ? historyParams : params,
          pendingBarcodeAeNoRef,
          redirectCallBack,
          isIpad,
          isLogin: loginInfo?.flag,
        });
      }
    } catch (error) {
      handleAdmissionFormRedirect({
        forceClear: true,
        params: {},
        pendingBarcodeAeNoRef,
      });
    }
  };

  useEffect(() => {
    getTicketList();
    const interval = setInterval(() => {
      getTicketList();
    }, 1000 * 20);

    return () => clearInterval(interval);
  }, [
    loginInfo,
    query.ticketType,
    query.tableName,
    filter,
    refreshTicketList,
    sort,
    tableType,
    historySubTabValue,
    isBsMode,
    refresh,
  ]);

  const getSpecialty = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialty();
      setSpecialty(result);
    } catch (error) {}
  }, []);

  const getAdmBusstopList = useCallback(async () => {
    try {
      const params = {
        type: '',
      };
      const { result } = await eadmissionAPI.getAdmBusstopList(params);
      setBusstopOptions(result);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getSpecialty();
    getAdmBusstopList();
  }, [getSpecialty, getAdmBusstopList]);

  useEffect(() => {
    (async () => {
      if (!loginInfo?.hospitalId || !loginInfo?.wardId) {
        return;
      }
      const options = await fetchTransferInPopupOptions(loginInfo);
      setTransferInPopupOptions(options);
    })();
  }, [loginInfo?.hospitalId, loginInfo?.wardId, refresh]);

  const specialtyList = useMemo(() => {
    return _.uniqBy(
      _.concat(
        _.map(_.concat(specialty.specialtyCodes, specialty.subSpecialtyCodes), (item) => ({
          text: item,
          value: item,
        })),
        filter.specialtys
      ),
      'value'
    );
  }, [specialty, filter.specialtys]);

  const busstopList = useMemo(() => {
    return _.map(busstopOptions, (item) => ({
      text: item.value,
      value: item.key,
    }));
  }, [busstopOptions]);

  const handleAck = (adTicketId) => async () => {
    try {
      if (loginInfo.flag) {
        const params = {
          adTicketId,
        };
        await eadmissionAPI.ackTicket(params);
        setRefreshTickets((o) => !o);
        setRefreshTicketList((o) => !o);
      } else {
        setIsShowLoginPop(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAckAll = async () => {
    try {
      if (loginInfo.flag) {
        const params = {
          tableName: query.tableName,
          ticketType: query.ticketType,
        };
        await eadmissionAPI.ackAllTicket(params);
        setRefreshTickets((o) => !o);
        setRefreshTicketList((o) => !o);
      } else {
        setIsShowLoginPop(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBsMlookupList = async () => {
    try {
      const { result } = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(result);
    } catch (error) {
      console.log(error);
    }
  };

  const editSaveHandle = async (requestVal, editIndex) => {
    try {
      if (isTI) {
        await bedStatusAPI.postUpdateBsBooking(requestVal);
      } else {
        await bedStatusAPI.postUpdateBsTransferOutRequest(requestVal);
      }
      getTicketList();
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const handleExport = async (protectKey) => {
    try {
      const params = {
        ...historyParams,
        protectKey,
        hospId: loginInfo?.hospitalId,
        wardId: loginInfo?.wardId,
      };

      if (
        moment(filter.startDate).isBetween(
          moment(filter.endDate).add(-3, 'days').add(-1, 'minutes'),
          moment(filter.endDate),
          'day',
          '[]'
        )
      ) {
        await downloadFileById(
          () => {
            return isBsMode
              ? eadmissionAPI.getBsTicketExportRequest(params)
              : eadmissionAPI.getTicketExportRequest(params);
          },
          () => {
            return `AckHistory Excel_${moment().valueOf()}`;
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClosePopup = () => {
    setRefreshTickets((o) => !o);
    setRefreshTicketList((o) => !o);
  };

  const handleAeNoBarcodeScan = useCallback((scanValue) => {
    if (!scanValue) {
      return;
    }
    pendingBarcodeAeNoRef.current = scanValue;
  }, []);

  const handleResetFilter = () => {
    pendingBarcodeAeNoRef.current = '';
    setFilter(initDefaultFilter);
  };

  const handleOpenEAdmissionTransferInPop = (data) => {
    if (!loginInfo?.flag) {
      setIsShowLoginPop(true);
      return;
    }
    setTransferInEditData(data);
    setIsTransferInPopOpen(true);
  };

  const handleCloseEAdmissionTransferInPop = () => {
    setIsTransferInPopOpen(false);
    setTransferInEditData(null);
  };

  const handleSaveEAdmissionTransferIn = async (data) => {
    try {
      handleCloseEAdmissionTransferInPop();
      await eadmissionAPI.updateTransferInRequest(buildUpdateTransferInParams(data));
      await getTicketList();
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      }
    }
  };

  const isFilter = useMemo(() => {
    return (
      filter.sex ||
      filter.aeNo ||
      filter.specialtys?.length > 0 ||
      filter.busstop?.length > 0 ||
      (filter.waitTime !== '' && filter.waitTime !== '0')
    );
  }, [filter]);

  const isBsHistoryTransferIn = isHistory && historySubTabValue === 1 && isBsMode;
  const isBsHistoryTransferOut = isHistory && historySubTabValue === 2 && isBsMode;
  const isTicketTable =
    (isAdm && !isHistory) || (isHistory && !isBsMode) || (isHistory && isBsMode && historySubTabValue === 0);

  const renderTable = () => {
    if (isEAdmissionTI) {
      return (
        <EAdmissionTITable
          data={ticketList.data}
          openEdit={handleOpenEAdmissionTransferInPop}
          handleUpdateSingleData={getTicketList}
          handleRowDoubleClick={({ rowData }) => handleOpenEAdmissionTransferInPop(rowData)}
        />
      );
    }

    if (isTI || isBsHistoryTransferIn) {
      return (
        <BookingTable
          allData={ticketList.data}
          saveHandle={editSaveHandle}
          ref={tableRef}
          bsMlookupList={BsMlookupList}
          nextPageCall={() => getBsMlookupList()}
          ticket={true}
          handleAck={handleAck}
          handleClosePopup={handleClosePopup}
          isHistory={isHistory}
          padding="0"
        />
      );
    }

    if (isTO || isBsHistoryTransferOut) {
      return (
        <TransferOutTable
          allData={ticketList.data}
          saveHandle={editSaveHandle}
          ref={tableRef}
          bsMlookupList={BsMlookupList}
          nextPageCall={() => getBsMlookupList()}
          ticket={true}
          handleAck={handleAck}
          isHistory={isHistory}
          minHeight="calc(100vh - 26rem)"
          padding="0"
        />
      );
    }

    if (isTicketTable) {
      return (
        <TicketTable
          data={initData(ticketList.data)}
          handleAck={handleAck}
          filterData={filter}
          sort={sort}
          setSort={setSort}
          ticketType={query.ticketType}
          setRefreshTicketList={setRefreshTicketList}
          isHistory={isHistory}
          isBsMode={isBsMode}
        />
      );
    }

    return null;
  };

  return (
    <div className={classes.root}>
      <ActionableHeader setRefresh={setRefresh} />
      <Box p="1rem 1.5rem" flex="1" display="flex" flexDirection="column">
        <Box display="flex" gridGap="0.62rem" flexWrap="wrap">
          {tabs.map((item) => (
            <ButtonBase
              className={classNames(
                classes.tab,
                item.flag ? classes.selected : classes.unSelected,
                item.falsh && actionableSetting.flashAlert ? classes.flash : ''
              )}
              disabled={item.disabled}
              onClick={handleSelect(item.ticketType, item.tableName)}
              style={{
                backgroundColor: item?.flag ? '' : ACTIONABLE_TICKET_MAPPING[item?.ticketType]?.bgColor ?? '',
                color: item?.flag ? '' : ACTIONABLE_TICKET_MAPPING[item?.ticketType]?.color ?? '',
              }}
              key={item.ticketType}
            >
              {`${item.desc} (${query.ticketType === item.ticketType ? ticketList.data?.length : item.count}) ${
                query.ticketType === item.ticketType && isAdm && isFilter ? 'filtered' : ''
              }`}
            </ButtonBase>
          ))}
          <ButtonBase
            className={classNames(classes.tab, isHistory ? classes.selected : classes.unSelected)}
            onClick={handleSelect('history')}
            // style={{
            //   backgroundColor: isHistory ? '' : ACTIONABLE_TICKET_MAPPING[item.ticketType].bgColor,
            //   color: isHistory ? '' : ACTIONABLE_TICKET_MAPPING[item.ticketType].color,
            // }}
          >
            Ack. History
          </ButtonBase>
        </Box>
        <Box
          bgcolor="#FFFFFF"
          borderRadius="0 0.9375rem 0.9375rem 0.9375rem"
          flex="1"
          p="1rem"
          display="flex"
          flexDirection="column"
        >
          {/* sub tab */}
          {isBsMode && isHistory && (
            <div className={classes.tabHeader}>
              <Box display="flex" gridGap="1.25rem" className={classes.tabBox}>
                {subTabList.map((item) => (
                  <ButtonBase
                    id={item.value}
                    key={item.value}
                    className={item.value === historySubTabValue ? classes.tabSelected : classes.tabUnSelected}
                    onClick={handleSelectSubTab(item)}
                  >
                    {item.title}
                  </ButtonBase>
                ))}
              </Box>
            </div>
          )}
          {/* Filter */}
          <Box display="flex" gridGap="0.75rem" alignItems="center" justifyContent="space-between" mb="0.7rem">
            <Box display="flex" gridGap="0.75rem" alignItems="center" flexWrap="wrap">
              {isAdm &&
                (isHistory ? (
                  <AckHistoryFilter
                    specialtyList={specialtyList}
                    filter={filter}
                    handleFilterSelect={handleFilterSelect}
                    GENDER={[{ text: '', value: '' }, ...GENDER]}
                    WT={WT}
                    handleReset={handleResetFilter}
                    isBsMode={isBsMode}
                    historySubTabValue={historySubTabValue}
                    busstopList={busstopList}
                    handleAeNoBarcodeScan={handleAeNoBarcodeScan}
                  />
                ) : (
                  <>
                    <Text color="#3E3E3E" fontSize="1rem">
                      Filter:
                    </Text>
                    <AutoCompleteMultiCheckbox
                      itemList={specialtyList}
                      value={filter.specialtys}
                      onChange={handleFilterSelect('specialtys')}
                      width="8rem"
                      height="2.5625rem"
                      placeholder="Specialty"
                      freeSolo
                      highlight="#FFFFCC"
                      selectAll={false}
                    />
                    <AutoCompleteInput
                      itemList={[{ text: '', value: '' }, ...GENDER]}
                      value={filter.sex}
                      onChange={handleFilterSelect('sex')}
                      width="6rem"
                      height="2.5625rem"
                      placeholder="Gender"
                      highlight="#FFFFCC"
                    />
                    <AutoCompleteInput
                      itemList={WT}
                      value={filter.waitTime}
                      onChange={handleFilterSelect('waitTime')}
                      width="6rem"
                      height="2.5625rem"
                      placeholder="W.T."
                      highlight="#FFFFCC"
                    />
                    <AutoCompleteMultiCheckbox
                      itemList={busstopList}
                      value={filter.busstop}
                      onChange={handleFilterSelect('busstop')}
                      width="15rem"
                      height="2.5625rem"
                      placeholder="Bus Stop"
                      freeSolo
                      highlight="#FFFFCC"
                      selectAll={false}
                    />
                    {!isBsMode && (
                      <AeNoScanInput
                        value={filter?.aeNo}
                        onChange={handleFilterSelect('aeNo')}
                        onBarcodeScan={handleAeNoBarcodeScan}
                        width="10rem"
                      />
                    )}
                    <ButtonBase className={classes.reset} onClick={handleResetFilter}>
                      Reset
                    </ButtonBase>
                    <BrowserAlertByFilter />
                  </>
                ))}
            </Box>
            {ticketList.ackAllDisplay && <StyleButton type="fill" text="Ack. All" onClick={handleAckAll} />}
            {isHistory && (
              <StyleButton
                type="fill"
                text="Export"
                Icon={DocIcon}
                minWidth="6.875rem"
                onClick={() => {
                  if (!loginInfo?.flag) {
                    setIsShowLoginPop(true);
                    return;
                  }
                  exportPwdExcel(handleExport)();
                }}
              />
            )}
          </Box>

          {renderTable()}
        </Box>
      </Box>
      {isShowLoginPop && (
        <LoginPop closehandle={() => setIsShowLoginPop(false)} submitHandle={() => setIsShowLoginPop(false)} />
      )}
      {isTransferInPopOpen && (
        <TransferInPop
          open={isTransferInPopOpen}
          closePop={handleCloseEAdmissionTransferInPop}
          title="Transfer In Request"
          allData={transferInEditData}
          saveHandle={handleSaveEAdmissionTransferIn}
          transferInPopupOptions={transferInPopupOptions}
        />
      )}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#F1F6FF',
    display: 'flex',
    flexDirection: 'column',
  },
  '@keyframes backgroundAnimation': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.3 },
    '100%': { opacity: 1 },
  },
  flash: {
    fontFamily: 'NotoSans-Medium',
    animation: '$backgroundAnimation 2s infinite',
  },
  tab: {
    width: '14.875rem',
    height: '3.875rem',
    borderRadius: '0.625rem 0.625rem 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    color: '#538FFF',
    cursor: 'pointer',
    textAlign: 'center',
    fontFamily: 'NotoSans-Medium',
    padding: '0.5rem',
    '&.Mui-disabled': {
      backgroundColor: 'rgba(165,165,165, 0.1047) !important',
      color: 'rgba(158,158, 158,0.6) !important',
      animation: 'unset',
    },
  },
  unSelected: {
    // backgroundColor: 'rgba(83, 143, 255, 0.1047)',
    // color: 'rgba(83, 143, 255, 0.6)',
    opacity: '0.6',
    fontFamily: 'NotoSans-Medium',
    // animation: '$backgroundAnimation 2s infinite',
  },
  selected: {
    color: '#538FFF',
    backgroundColor: '#FFFFFF',
    fontFamily: 'NotoSans-Bold',
  },
  reset: {
    color: '#538FFF',
    fontSize: '1rem',
    textDecoration: 'underline',
    fontFamily: 'NotoSans-Bold',
  },
  detailBtn: ({ detailOpen }) => ({
    fontFamily: 'NotoSans-Medium',
    color: detailOpen ? '#7d86a9' : '#fff',
    fontSize: '1rem',
    width: '11.25rem',
    minWidth: '11.25rem',
    height: '2rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '4px',
    backgroundColor: detailOpen ? '#fff' : '#7d86a9',
  }),
  dropIcon: {
    fontSize: '0.875rem',
    marginLeft: '1rem',
  },
  tabBox: {
    display: 'flex',
    paddingBottom: '0.875rem',
    borderBottom: 'solid 0.063rem #d9d9d9',
    width: '100%',
  },
  tabSelected: {
    borderRadius: '20px',
    width: '8rem',
    padding: '0.56rem 0.94rem',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#ffffff',
  },
  tabUnSelected: {
    borderRadius: '20px',
    width: '8rem',
    padding: '0.56rem 0.94rem',
    backgroundColor: '#f5faff',
    fontSize: '1rem',
    color: '#c0c6cb',
    border: 'solid 1px #c0c6cb',
  },
}));

// 完全重置
const initDefaultFilter = () => {
  return {
    sex: '',
    specialtys: [],
    waitTime: '',
    ackBy: '',
    startDate: moment().add(-6, 'hours'),
    endDate: moment(),
    corpId: '',
    busstop: [],
    aeNo: '',
  };
};

// 从storage上获取的过滤条件
const initFilter = () => {
  const filter = initAdmissionFilter();
  return {
    sex: '',
    specialtys: filter.specialtys,
    waitTime: '',
    busstop: [],
    ackBy: '',
    startDate: moment().add(-6, 'hours'),
    endDate: moment(),
    corpId: '',
    aeNo: '',
  };
};

const initData = (data) => {
  return _.flatMap(data, (obj) => [
    { ...obj, display: true, otherInfo: false, busStopRow: false },
    { ...obj, display: true, otherInfo: true, busStopRow: false },
  ]);
};

const subTabList = [
  {
    value: 0,
    title: 'E-Adm.',
  },
  // {
  //   value: 1,
  //   title: 'T/I Req.',
  // },
  {
    value: 2,
    title: 'T/O Req.',
  },
];

const ACK_BS_HISTORY_ENUM = ['E-Adm', 'T/I Req', 'T/O Req'];

const transferInType = ['PFYA', 'PDWR'];

const transferOutType = ['ATO', 'RTO', 'PWAT'];

export default ActionableDashboard;
